import React from 'react';

import ActionButton from 'jbc-front/components/ActionButton';
import Expand from 'jbc-front/components/icons/Expand';
import { useTranslation } from 'react-i18next';

const ExpandActionBtn = props => {
  const { t } = useTranslation();
  const { onClick, label = t('buttons.ExpandActionBtn.ExpandActionBtn.Expand_all'), ...rest } = props;
  return (
    <ActionButton as="button" icon={<Expand />} onClick={onClick} {...rest}>
      {label}
    </ActionButton>
  );
};

export default ExpandActionBtn;
